import type { IBankTableColumns } from '@entities/bank';
import { useBanks } from '@entities/bank';
import ModalOpenBtn from '@features/modal-open-btn';
import ErrorMessage from '@shared/components/ErrorMessage';
import Loading from '@shared/components/Loading';
import LoadingSpinner from '@shared/components/LoadingSpinner';
import { Pagination, PaginationRows } from '@shared/components/Pagination';
import {
  Table,
  THead,
  TBody,
  TableActions,
  TableActionsItem,
  TableContainer,
  TableProvider,
} from '@shared/components/Table';

import { useTableSettings } from './settings/useTableSettings';

const SettingsBanksWidget = () => {
  const {
    banks,
    isLoading,
    isError,
    error,
    isFetching,
    refetch,

    filter,
  } = useBanks();

  const { columnTitles, renderRow, NewBank } = useTableSettings({
    refetch,
  });

  if (isLoading) return <LoadingSpinner />;
  if (isError) return <ErrorMessage error={error} />;

  if (banks) {
    return (
      <>
        {isFetching && <Loading />}

        <TableProvider<IBankTableColumns> columnTitles={columnTitles} {...filter}>
          <TableActions>
            <TableActionsItem>
              <ModalOpenBtn text='New' modalContent={<NewBank />} />
            </TableActionsItem>
          </TableActions>

          <TableContainer>
            <Table>
              <THead />
              <TBody items={banks.data} renderItem={renderRow} />
            </Table>
          </TableContainer>
          <div className='pagination-container'>
            <Pagination data={banks.meta} />
            <PaginationRows />
          </div>
        </TableProvider>
      </>
    );
  }

  return null;
};

export default SettingsBanksWidget;
